import styled from "styled-components";
import { flex, responsive } from "../../mixins";

export const Wrapper = styled.section`
  ${flex({
    alignItem: "start",
  })}

  h3 {
    color: var(--text-color);
    margin: 3px;
  }
  h4 {
    margin: 3px;
    text-transform: none;
  }

  .light {
    background-image: linear-gradient(
      to right,
      #f97316,
      #b45309,
      #fca5a5,
      #4d7c0f,
      #047857,
      #eab308,
      #3730a3,
      #6b21a8,
      #a3e635,
      #9f1239
    );
  }
  .dark {
    background-image: linear-gradient(
      to right,
      #fed7aa,
      #fef08a,
      #d9f99d,
      #bbf7d0,
      #99f6e4,
      #a5f3fc,
      #bfdbfe,
      #ddd6fe,
      #f5d0fe,
      #fecdd3
    );
  }

  ${responsive.tablet.standard`
    ${flex()}
    h3 {
      font-size: 1.563rem;
    }
    h4 {
      font-size: 1.25rem;
    }
  `}
`;

export const Hi = styled.span`
  font-weight: bold;
  color: var(--red-light);
`;
